import {generatePath, UserId} from '@legit.health/ui';
import {ConditionsInfo} from '@/shared/components/diagnosticReport/DiagnosticReportForm/types';
import useSuspenseApiQuery from '@/shared/hooks/useSuspenseApiQuery';

const PATH = '/patients/:patientId/pathologies-for-diagnostic-report-form';

export default function useConditionsInfo(patientId: UserId) {
  const path = generatePath(PATH, {patientId});
  return useSuspenseApiQuery<ConditionsInfo>({
    queryOptions: {
      queryKey: [PATH, patientId],
      staleTime: 0,
      gcTime: 0
    },
    requestArguments: {
      method: 'GET',
      path
    }
  });
}
